<mat-toolbar class="navbar-container">
  <ng-container *ngIf="logos$ | async as logos">
    <img class="logo" *ngFor="let portalLogo of logos.portalLogos" [src]="'data:image/jpg;base64,' + portalLogo"
      alt="portal logo" />
    <img class="logo" *ngFor="let siteLogos of logos.siteLogos" [src]="'data:image/jpg;base64,' + siteLogos"
      alt="site logo" />
  </ng-container>
  <span class="spacer"></span>

  <!-- Portals -->
  <button mat-button [matMenuTriggerFor]="portalMenu">
    <ng-container *ngIf="selectedPortal$ | async as selectedPortal">
      {{ selectedPortal?.name }}
    </ng-container>
  </button>
  <mat-menu #portalMenu="matMenu" (closed)="clearPortalSearch(portalSearchInput)">
    <div class="search-container" (click)="$event.stopPropagation()">
      <input #portalSearchInput type="text" placeholder="Search site..." (input)="onPortalSearch($event)" (keydown)="$event.stopPropagation()" (keydown.esc)="clearPortalSearch(portalSearchInput)">
      <mat-icon *ngIf="portalSearch$ | async" class="clear-btn" (click)="clearPortalSearch(portalSearchInput)">close</mat-icon>
    </div>
    <div *ngIf="filteredPortals$ | async as filteredList">
      <button mat-menu-item *ngFor="let item of filteredList" (click)="onSelectedPortalChange(item)">
        {{ item.name }}
      </button>
      <div *ngIf="filteredList.length === 0" class="no-results">
        No sites found
      </div>
    </div>
  </mat-menu>

  <!-- Sites -->
  <button mat-button [matMenuTriggerFor]="siteMenu">
    <ng-container *ngIf="selectedSite$ | async as selectedSite">
      {{ selectedSite?.name }}
    </ng-container>
  </button>
  <mat-menu #siteMenu="matMenu">
    <button mat-menu-item *ngFor="let item of sites$ | async as list" (click)="onSelectedSiteChange(item)">
      {{ item.name }}
    </button>
  </mat-menu>

  <!-- Telemetry Alert Notification -->
  <ng-container *ngIf="isSuperAdmin$ | async">
    <ng-container *ngIf="loggerAlertCount$ | async as alertCount">
      <button mat-icon-button [matMenuTriggerFor]="alertMenu" *ngIf="alertCount > 0" class="alert-nav-btn" style="color: #f5b041; margin-right: 8px; position: relative;">
        <mat-icon style="font-size: 24px;">warning</mat-icon>
        <span class="custom-badge">{{ alertCount }}</span>
      </button>
    </ng-container>
  </ng-container>

  <mat-menu #alertMenu="matMenu" class="telemetry-alert-menu">
    <div class="alert-menu-header" (click)="$event.stopPropagation()">
      <mat-icon class="warning-icon" style="color: #f5b041; margin-right: 8px; vertical-align: middle;">warning</mat-icon>
      <h3 style="display: inline-block; margin: 0; font-size: 1rem; color: #fff; font-weight: 600; vertical-align: middle;">Telemetry Alert</h3>
    </div>
    <div class="alert-menu-content" (click)="$event.stopPropagation()" style="padding: 10px 0; color: #bbb; font-size: 0.9rem;">
      <span *ngIf="loggerAlertCount$ | async as alertCount">
        {{ alertCount }} logger(s) require attention
      </span>
    </div>
    <div class="alert-menu-actions" (click)="$event.stopPropagation()" style="text-align: right;">
      <button mat-flat-button color="warn" (click)="openLoggerHealthModal()">View Diagnostics</button>
    </div>
  </mat-menu>

  <!--User Manual-->
  <button mat-button [matMenuTriggerFor]="userMenu">User Menu</button>
  <mat-menu #userMenu="matMenu">
    <a mat-menu-item  [href]="userManuelUrl$ | async" target="_blank">
      <svg-icon class="d-inline-block me-2" src="assets/images/svg/nav-bar/User Mannual.svg"
        [svgStyle]="{ 'width.px':20,'height.px': 20,'fill':'#fff'}">
      </svg-icon>
      <span>User Manual</span>
    </a>
    <button mat-menu-item (click)="openDashboardReport()">
      <svg-icon class="d-inline-block me-2" src="assets/images/svg/nav-bar/Dashboard Report.svg"
        [svgStyle]="{ 'width.px':20,'height.px': 20,'fill':'#fff'}">
      </svg-icon>
      <span>Dashboard Report</span>
    </button>
    <button mat-menu-item (click)="openAggregatedReport()">
      <svg-icon class="d-inline-block me-2" src="assets/images/svg/nav-bar/Aggregate.svg"
        [svgStyle]="{ 'width.px':20,'height.px': 20,'fill':'#fff'}">
      </svg-icon>
      <span>Aggregated Report</span>
    </button>
    <button mat-menu-item (click)="openReportGenerator()">
      <mat-icon class="d-inline-block me-2" style="font-size: 20px; width: 20px; height: 20px; color: #fff;">picture_as_pdf</mat-icon>
      <span>Generate Report</span>
    </button>
    <button mat-menu-item (click)="openBillUploadModal()">
      <mat-icon class="d-inline-block me-2" style="font-size: 20px; width: 20px; height: 20px; color: #fff;">upload_file</mat-icon>
      <span>Upload Bills</span>
      <span *ngIf="(pendingConfirmation$ | async) as pending"
        title="Bills awaiting overwrite confirmation"
        style="background:#b26a00;color:#fff;border-radius:10px;padding:0 7px;margin-left:6px;font-size:12px;line-height:18px;">{{ pending }}</span>
    </button>
    <button *ngIf="isSuperAdmin$ | async" mat-menu-item (click)="openImportModal()">
      <mat-icon class="d-inline-block me-2" style="font-size: 20px; width: 20px; height: 20px; color: #fff;">cloud_upload</mat-icon>
      <span>Import Meter Data</span>
    </button>
    <!-- Map option hidden until Google Maps billing and site coordinate data are ready.
    <button  mat-menu-item (click)="openMap()">
      <svg-icon class="d-inline-block me-2" src="assets/images/svg/nav-bar/Map.svg"
        [svgStyle]="{ 'width.px':20,'height.px': 20,'fill':'#fff'}">
      </svg-icon>
      <span>Map</span>
    </button>
    -->
  </mat-menu>

  <button mat-button color="warn" (click)="onLogout()">Logout</button>
</mat-toolbar>